import NotFound from './views/NotFound'
import Document from './views/Documents'

export default [
  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
    meta: {
      guest: true
    }
  },
  {
    path: '/password/forgot',
    name: 'password-forgot',
    component: () => import(/* webpackChunkName: "password_forgot" */ './views/ForgotPassword.vue'),
    meta: {
      guest: true
    }
  },
  {
    path: '/password/forgot/confirmation',
    name: 'password-forgot-confirmation',
    component: () => import(/* webpackChunkName: "password_forgot_confirmation" */ './views/ForgotPasswordConfirmation.vue'),
    meta: {
      guest: true
    }
  },
  {
    path: '/password/reset/confirmation',
    name: 'password-reset-confirmation',
    component: () => import(/* webpackChunkName: "password_reset_confirmation" */ './views/ResetPasswordConfirmation.vue'),
    meta: {
      guest: true
    }
  },
  {
    path: '/password/reset/:id/:token',
    name: 'password-reset',
    component: () => import(/* webpackChunkName: "password_reset" */ './views/ResetPassword.vue'),
    meta: {
      guest: true
    }
  },
  {
    path: '/law-firm/selection',
    name: 'law-firm-selection',
    component: () => import(/* webpackChunkName: "law_firm_selection" */ './views/LawFirmSelection.vue')
  },
  {
    path: '/',
    name: 'home',
    // component: Home
    redirect: {
      name: 'matters'
    }
  },
  {
    path: '/matters',
    name: 'matters',
    component: () => import(/* webpackChunkName: "matters" */ './views/Matters.vue')
  },
  {
    path: '/documents',
    name: 'documents',
    // component: () => import(/* webpackChunkName: "documents" */ './views/Documents.vue')
    component: Document
  },
  {
    path: '/invoices',
    name: 'invoices',
    component: () => import(/* webpackChunkName: "invoices" */ './views/Invoices.vue')
  },
  {
    path: '/parameters',
    name: 'parameters',
    component: () => import(/* webpackChunkName: "parameters" */ './views/Parameters.vue')
  },
  { path: '/404',
    name: 'not-found',
    component: NotFound,
    meta: {
      guest: true
    }
  },
  {
    path: '*',
    redirect: '/404',
    meta: {
      guest: true
    }
  }
]
